import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d8081b62&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d8081b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8081b62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8081b62')) {
      api.createRecord('d8081b62', component.options)
    } else {
      api.reload('d8081b62', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d8081b62&scoped=true&", function () {
      api.rerender('d8081b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yzaxAEWPVEs2/JS/comp/PopupBox.vue"
export default component.exports